import React from "react";
import { BannerContainer } from "../../components/Banner/BannerContainer";
import { BannerImage } from "../../components/Banner/BannerImage";
import { BannerTitle } from "../../components/Banner/BannerTitle";
import bannerImage from "../../assets/banner.jpg";

export const BannerSection = () => {
  return (
    <BannerContainer>
      <BannerImage
        src={bannerImage}
        alt="ARB Service Centre Banner"
        aria-label="ARB Service Centre Banner."
      />
      <BannerTitle>ARB SERVICE CENTRE</BannerTitle>
    </BannerContainer>
  );
};
